import type { PrepackageSearchState } from '../types';

export const ppDefaultState: PrepackageSearchState = {
    searchType: 'fixed',
    originAirport: '',
    destination: '',
    destinationCountry: undefined,
    destinationCity: undefined,
    boundingBox: undefined,
    departureDate: null,
    returnDate: null,
    flexibleDeparture: 3,
    duration: {
        from: 5,
        to: 15,
    },
    totalOffers: null,
    travelMonths: [],
    numberOfAdults: 2,
    agesOfChildren: [],
};
